export default {"src":"/_next/static/media/healthcare.325684e2.svg","height":47,"width":50,"blurWidth":0,"blurHeight":0};